module.exports = __webpack_public_path__ + "img/DE01444.1886c9f8.png";